// extracted by mini-css-extract-plugin
export default {"card":"XY-z","carouselContainer":"YY-z","carouselContent":"ZY-z"};